export default "__VITE_ASSET__t1LdHI8n__"